<template>
    <div>
        <Jueces @goToList="goToList" />
    <procesos-list v-if="!process" ref="list" @go-to-details="goToDetails" />
    <process-details
      :process="process"
      ref="details"
      v-if="process"
      @clear-process-id="process = null"
    />
    </div>
</template>
<script>
import Jueces from '@/components/process/Jueces';
import ProcesosList from "@/components/process/ProcesosList";
import ProcessDetails from "@/views/process/ProcessDetails";

export default {
    data() {
        return {
            process: null,
        };
    },    
    components: {
        Jueces,
        ProcesosList,
        ProcessDetails
    },
    methods: {
        goToList() {
            this.process = null;
            this.$vuetify.goTo(this.$refs.list);
        },
        goToDetails(process) {
            this.process = process;
        },
    },
    created() {
        this.$store.dispatch(
            'process/setUrlAyuda',
            '/manual/consulta.html#consulta-por-juez-magistrado-o-clase-de-proceso',
        );
    },
};
</script>
